(function () {
    const MAX_ATTEMPTS = 20;
    const RETRY_DELAY_MS = 250;
    let consumed = false;
    let attempts = 0;

    function getRequestedSymbol() {
        try {
            const params = new URLSearchParams(window.location.search);
            const rawSymbol = (params.get('symbol') || '').trim();
            if (!rawSymbol) return '';

            const symbol = rawSymbol.toUpperCase().replace(/\s+/g, '');
            if (!/^[A-Z0-9._:-]{1,24}$/.test(symbol)) {
                if (__LOG_WARN__) AppLog.warn('[url-symbol-loader] Ignoring invalid symbol URL parameter:', rawSymbol);
                return '';
            }
            return symbol;
        } catch (error) {
            if (__LOG_WARN__) AppLog.warn('[url-symbol-loader] Failed to read symbol URL parameter:', error);
            return '';
        }
    }

    function normalizeForMatch(symbol) {
        return String(symbol || '').trim().toUpperCase();
    }

    function findMatchingStockBar(symbol) {
        const target = normalizeForMatch(symbol);
        const targetWithoutExchange = target.includes(':') ? target.split(':').pop() : target;
        const visualizerEl = document.getElementById('stock-3d-cube');
        const visualizer = visualizerEl
            && visualizerEl.components
            && visualizerEl.components['stock-cube-visualizer'];

        if (!visualizer || !visualizer.stockBars || visualizer.stockBars.size === 0) {
            return null;
        }

        for (const [ticker, barInfo] of visualizer.stockBars.entries()) {
            const stock = barInfo && barInfo.stock ? barInfo.stock : null;
            const candidates = [
                ticker,
                stock && stock.ticker,
                stock && stock.symbol,
                stock && stock.T
            ].filter(Boolean).map(normalizeForMatch);

            if (candidates.includes(target) || candidates.includes(targetWithoutExchange)) {
                return barInfo && barInfo.bar ? barInfo.bar : null;
            }
        }

        return null;
    }

    function createFallbackStock(symbol) {
        const ticker = symbol.includes(':') && !symbol.startsWith('I:') ? symbol.split(':').pop() : symbol;

        return {
            ticker,
            todaysChangePerc: 0,
            price: 0,
            volume: 0,
            tickerSummary: {
                name: ticker,
                primary_exchange: 'Unknown Exchange',
                market_cap: 0,
                previous_close: 0
            }
        };
    }

    function getStockBarComponent(el) {
        if (!el || !el.components || !el.components['stock-bar']) {
            return null;
        }

        return el.components['stock-bar'];
    }

    function findSelectionComponent() {
        const visualizerEl = document.getElementById('stock-3d-cube');
        const visualizer = visualizerEl
            && visualizerEl.components
            && visualizerEl.components['stock-cube-visualizer'];

        if (visualizer && visualizer.stockBars && visualizer.stockBars.size > 0) {
            for (const barInfo of visualizer.stockBars.values()) {
                const component = getStockBarComponent(barInfo && barInfo.bar);
                if (component) return component;
            }
        }

        const stockBarEls = document.querySelectorAll('[stock-bar]');
        for (const el of stockBarEls) {
            const component = getStockBarComponent(el);
            if (component) return component;
        }

        return null;
    }

    function selectWithComponent(stockBar, stock) {
        if (!stockBar || typeof stockBar.selectStock !== 'function') {
            return false;
        }

        stockBar.selectStock(stock).catch((error) => {
            if (__LOG_ERROR__) AppLog.error('[url-symbol-loader] Failed to select URL symbol:', error);
        });
        return true;
    }

    function trySelectSymbol() {
        if (consumed) return;

        const symbol = getRequestedSymbol();
        if (!symbol) return;

        attempts += 1;

        const matchingBar = findMatchingStockBar(symbol);
        const matchingComponent = getStockBarComponent(matchingBar);
        if (matchingComponent) {
            const stock = matchingComponent.getResolvedStockData
                ? matchingComponent.getResolvedStockData()
                : createFallbackStock(symbol);

            if (selectWithComponent(matchingComponent, stock)) {
                consumed = true;
                return;
            }
        }

        const selectionComponent = findSelectionComponent();
        if (selectionComponent) {
            consumed = true;
            selectWithComponent(selectionComponent, createFallbackStock(symbol));
            return;
        }

        if (attempts < MAX_ATTEMPTS) {
            setTimeout(trySelectSymbol, RETRY_DELAY_MS);
            return;
        }

        consumed = true;
        const scene = document.querySelector('a-scene');
        if (scene) {
            scene.emit('stock-selected', createFallbackStock(symbol));
        }
        if (__LOG_WARN__) AppLog.warn('[url-symbol-loader] Could not find a stock selection context for:', symbol);
    }

    function scheduleSelectSymbol() {
        if (consumed || !getRequestedSymbol()) return;
        setTimeout(trySelectSymbol, 0);
    }

    document.addEventListener('stock-data-loaded', scheduleSelectSymbol);
    document.addEventListener('center-panel-initialized', scheduleSelectSymbol);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scheduleSelectSymbol);
    } else {
        scheduleSelectSymbol();
    }
})();
